<template>
  <div>
    <Head title="Create Day Log" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/daylogs">Day Log</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-gray-200 rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap mb-4 p-4">

            <SelectInput class="pb-8 pr-6 w-full lg:w-1/3" id="jobsite_id" v-model="form.jobsite_id" disabled="disabled"><option>--Select a Jobsite--</option><option v-for="jobsite in this.jobsites.data" :value="jobsite.id">{{jobsite.sitename}}</option></SelectInput><br/><br/>
            <span class="pb-8 pr-6 w-full lg:w-1/3">
              Report Day:<br/>
              <datepicker v-model="form.reportday" id="newreportday" disabled="disabled" :enableTimePicker="false" autoApply :error="form.errors.reportday" class="mt-2" label="Report Day" />
            </span>
            <text-input v-model="form.superintendent" :error="form.errors.superintendent" class="pb-8 pr-6 w-full lg:w-1/3" label="Superintendent" />
            <text-input v-model="form.temp_low" :error="form.errors.temp_low" class="pb-8 pr-6 w-full lg:w-1/5" label="Low Temp" />
            <text-input v-model="form.temp_high" :error="form.errors.temp_high" class="pb-8 pr-6 w-full lg:w-1/5" label="High Temp" />
            <text-input v-model="form.other_weather" :error="form.errors.other_weather" class="pb-8 pr-6 w-full lg:w-1/2" label="Other Weather" />
            <div class="w-full p-4">
              
              <!--<icon name="lightning-bolt" class="flex-shrink-0 ml-2 w-3 h-3 fill-yellow-200" />-->Rain
              <input type="checkbox" id="rain"  v-model="form.rain" :error="form.errors.rain" class="pb-8 pr-6 mr-9 mb-4" label="Rain" />

              <!--<icon name="sparkles" class="flex-shrink-0 ml-2 w-3 h-3 fill-white" />-->Snow
              <input type="checkbox" id="snow"  v-model="form.snow" :error="form.errors.snow" class="pb-8 pr-6 mr-9 mb-4" label="Snow" />

              <!--<icon name="inbox" class="flex-shrink-0 ml-2 w-3 h-3 fill-blue-400" />-->Ice
              <input type="checkbox" id="ice"  v-model="form.ice" :error="form.errors.ice" class="pb-8 pr-6 mr-9 mb-4" label="Ice" />

              <!--<icon name="paper-airplane" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-100" />-->Wind
              <input type="checkbox" id="wind"  v-model="form.wind" :error="form.errors.wind" class="pb-8 pr-6 mr-9 mb-4" label="Wind" />

              <!--<icon name="sun" class="flex-shrink-0 ml-2 w-3 h-3 mr-4 fill-yellow-400" />-->Sun
              <input type="checkbox" id="sun"  v-model="form.sun" :error="form.errors.sun" class="pb-8 pr-6 mr-9 mb-4" label="Sun" />

              <!--<icon name="ban" class="flex-shrink-0 ml-2 w-3 h-3 fill-red-400" />-->
              Lost Production
              <input type="checkbox" id="lostday"  v-model="form.lostday" :error="form.errors.lostday" class="pb-8 pr-6 mr-9 mb-4" label="Lost Production" />
            </div>

            <div class="w-full pb-4">
              <div class="pb-4">Equipment Rentals & Material Deliveries for Subcontractors</div>
              <textarea v-model="form.rentals_deliveries" :error="form.errors.rentals_deliveries" class="pb-8 w-full"  ></textarea>
            </div>
            <div class="w-full pb-4">
              <div class="pb-4">Hindrance to Normal Progress</div>
              <textarea v-model="form.hinderance_notes" :error="form.errors.hinderance_notes" class="pb-8 w-full" label="Hindrance Notes" ></textarea>
            </div>
            <div class="w-full pb-4">
              <div class="pb-4">Additional Notes</div>
              <textarea v-model="form.additional_notes" :error="form.errors.additional_notes" class="pb-8 w-full" label="Additional Notes" ></textarea>
            </div>
        </div>

        <div id="workers" class="flex flex-wrap mb-4 p-4">
          <div class="w-full mb-4">
            <h2 class="mb-4 text-2xl font-bold">Worker Summary</h2> 
            <button class="signature-button p-2 mb-2 bg-yellow-200 font-bold noprint" @click="addRow">Add Row</button>
            <div id="workersumtable" class=""></div>
            <text-input v-model="form.workersummary" :error="form.errors.workersummary" id="workersum"  class="pb-8 w-full lg:w-1/2 hide" label="Worker Summary JSON" />
          </div>
        </div>

        <div class="flex flex-wrap p-4 hide">
          <label>
            <input
              type="checkbox"
              label="Include Inventory Report"
              v-model="form.inventoryupdate"
              :error="form.errors.inventoryupdate"
            />
            <span class="text-lg">&nbsp; Include Inventory Report</span>
          </label>
        </div>
        
        <text-input v-model="form.progress" :error="form.errors.progress" class="pb-8 pr-6 w-full lg:w-1/2 hide" label="Progress JSON" />
        <text-input v-model="form.orderupdates" :error="form.errors.orderupdates" class="pb-8 pr-6 w-full lg:w-1/2 hide" label="Order Updates JSON" />
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button v-if="(auth.user.role == 'ADMIN' || auth.user.role == 'USER')" :loading="form.processing" class="btn-indigo" type="submit">Create Day Log</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>
<style>
  .hide { display:none !important; opacity:0 !important; pointer-events:none !important; }
</style>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from '@vuepic/vue-datepicker';
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import '@vuepic/vue-datepicker/dist/main.css';
import moment from 'moment';
import Vue3Signature from "vue3-signature"

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Datepicker,
  },
  layout: Layout,
  remember: 'form',
  props: {
    orders: Object,
    jobsites: Object,
    auth: Object,
    purchaseorders: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
            jobsite_id: this.getPreJobsite(),
            superintendent: null,
            temp_low: null,
            temp_high: null,
            rain: null,
            snow: null,
            ice: null,
            wind: null,
            sun: null,
            lostday: null,
            other_weather: null,
            rentals_deliveries: null,
            hinderance_notes: null,
            additional_notes: null,
            progress: null,
            reportday: this.getPreDate(),
            orderupdates: null,
            workersummary: null,
      }),
    }
  },
  methods: {
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    saveitems() {
      event.preventDefault();
      this.daylog.workersummary = this.tabledata;
      this.form.workersummary = this.tabledata;
    },
    update() {
      event.preventDefault();
      if (document.querySelector('#workersum').value.length > 0) {
        var tdata =  JSON.parse(document.querySelector('#workersum').value);
        this.form.workersummary = JSON.stringify(tdata);
      } else {
        this.form.workersummary = '';
         console.warn(' Tabledata failure ');
      }
      this.store();
    },
    finalize() {
      event.preventDefault();
      if (document.querySelector('#workersum').value.length > 0) {
        var tdata =  JSON.parse(document.querySelector('#workersum').value);
        this.form.workersummary = JSON.stringify(tdata);
      } else { 
        this.form.workersummary = '';
        console.error(' Tabledata failure ')
      }
      this.store();
    },
    getPreDate() {
      var ncd = this.$inertia.page.url.split('d=')[1].split('&')[0];
      var newdatestring = ""; 
      if (ncd && (ncd.length > 4)) { newdatestring = ncd[4] + "" + ncd[5] + "" + "/" + ncd[6] + ncd[7] + "/" + ncd[0] + ncd[1] + ncd[2] + ncd[3]; }
      return newdatestring;
    },
    getPreJobsite() {
      var jsid = this.$inertia.page.url.split('j=')[1].split('&')[0];
      return jsid;
    },
    newtotal: (elem) => {
      var newtotal = (parseInt(document.querySelector('#inv-current-' + elem).textContent.replace(",","")) - parseInt(document.querySelector('#inv-changer-' + elem).value));
      document.querySelector('#inv-newtotal-' + elem).textContent = newtotal;
      //previousElementSibling
    },
    store() {
      var newdayformat = moment(this.form.reportday,'MM/DD/YYYY').format('YYYYMMDD');
      this.form.reportday = newdayformat;
      this.form.post('/daylogs')
    },
  },
}
</script>

<script setup>
import {reactive, ref} from 'vue'

const state = reactive({
  count: 0,
  option: {
    penColor: "rgb(0, 0, 0)",
    backgroundColor: "rgb(242,242,242)"
  },
  disabled: false
})

const signature1 = ref(null)

const save = (t) => {
  console.log(signature1.value.save(t))
}

const clear = () => {
  signature1.value.clear()
}

const undo = () => {
  signature1.value.undo();
}

const addWaterMark = () => {
  signature1.value.addWaterMark({
    text: "mark text",          // watermark text, > default ''
    font: "20px Arial",         // mark font, > default '20px sans-serif'
    style: 'all',               // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
    fillStyle: "red",           // fillcolor, > default '#333'
    strokeStyle: "blue",	       // strokecolor, > default '#333'
    x: 100,                     // fill positionX, > default 20
    y: 200,                     // fill positionY, > default 20
    sx: 100,                    // stroke positionX, > default 40
    sy: 200                     // stroke positionY, > default 40
  });
}

const fromDataURL = (url) => {
  event.preventDefault();
  signature1.value.fromDataURL(url);
}

const handleDisabled = () => {
  state.disabled = !state.disabled
}

var tabledata = [];

const addRow = () => {
    event.preventDefault();
    Table.addData([{workertype:'', manpower:0, workdesc:0 }])
};

var Table;
window.setTimeout(function() {
  Table = new Tabulator("#workersumtable", {
    reactiveData:false, //enable reactive data
    data:this.tabledata,
    rowHeight:60,
    layout:"fitData",
    columns:[
    {title:"Worker Type",field:"workertype",editor:"input"},
    {title:"Manpower",field:"manpower",editor:"number",editorParams:{min:0,max:9999999999,step:1}},
    {title:"Work Performed",field:"workdesc",editor:"textarea"},
    {title:"",formatter:"buttonCross", width:40, editable:true, editor:true, headerSort:false, hozAlign:"center", cellClick:function(e, cell){window.setTimeout(function() { cell.getRow().delete(); },5); }},
    ]
  });
  Table.on("cellEdited", function(cell) {
    tabledata = Table.getData();
    document.querySelector('#workersum').value = JSON.stringify(tabledata);
  });

},250);
</script>

<style scoped>
.example{
  margin: 0 auto;
}
.tabulator-row { height:50px; }
</style>